/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormReducerActions } from "./reducer-actions/form.reducer-actions";
import { QuestionReducerActions } from "./reducer-actions/question.reducer-actions";
import { StepReducerActions } from "./reducer-actions/step.reducer-actions";
import { correlatedValidation } from "./validation/validate-question";
import { validateQuestion } from "./validation/validate-question";
import { magenta } from "cms/utils/log/logger";

/**
 * @param {FormReducerDraftState} state 
 * @param {FormReducerAction} action 
 */
export function FormReducer (state, action) {

    const actions = [
        FormReducerActions,
        QuestionReducerActions,
        StepReducerActions,
    ];

    /** @type {FormReducerDraftState | false} */
    let result = false;

    for (const Action of actions) {
        result = Action(state, action);

        if (result) {
            break;
        }
    }

    if (!result) {
        throw new Error(`Action ${action.type} is not a valid type`);
    }
    // resolve computed properties
    const form = result?.form;
    let questions = form?.questions;
    result.count = questions?.length;
    
    if (!questions || !questions.length > 0) {
        questions = [];
        result.form.questions = questions;
    }
    const independentValidationErrors = questions?.flatMap(validateQuestion).filter(Boolean);
    const correlatedValidationErrors = correlatedValidation(questions);
    result.validationErrors = [...independentValidationErrors, ...correlatedValidationErrors];

    // an error occurs when doing this with question/set, so exclude it
    // the swap functionality already correctly sets the position, anyhow
    console.info(magenta(`Form Reducer ActionType: ${action.type}`), action.payload);
    if (action.type !== "question/set") {
        // ensure question positions are 1-based
        result?.form?.questions?.forEach((question, index) => {
            question.position = index + 1;
    
            if (question.step === 0) {
                question.step = 1;
            }
        });
    
        // ensure steps are 1-based
        result.form.steps.forEach((step, index) => {
            step.step = index + 1;
        });
    } else {
        // const questions = result.form.questions;
    }

    return result;
}
